import { createSlice } from "@reduxjs/toolkit";

const loadFromLocalStorage = () => {
  const savedState = localStorage.getItem("videosState");

  return savedState ? JSON.parse(savedState) : null;
};

const initialState = loadFromLocalStorage() || {
  videos: null,
  isVideoTourScreen: false,
  focusedIdx: null,
  items: [],
  selectedId: null,
};

const saveToLocalStorage = (state) => {
  localStorage.setItem("videosState", JSON.stringify(state));
};

export const videosSlice = createSlice({
  name: "videos",
  initialState,
  reducers: {
    setVideos: (state, action) => {
      state.videos = action.payload;
      saveToLocalStorage(state);
    },
    setIsVideoTourScreen: (state, action) => {
      state.isVideoTourScreen = action.payload;
      saveToLocalStorage(state);
    },
    setFocusedVideoIdx: (state, action) => {
      state.focusedIdx = action.payload;
      saveToLocalStorage(state);
    },
    setBadgeSwitchVideos: (state, action) => {
      state.items = action.payload;
      saveToLocalStorage(state);
    },
    setSelectedVideoSwitchId: (state, action) => {
      state.selectedId = action.payload;
      saveToLocalStorage(state);
    },
  },
});

export const selectVideos = (state) => state.videos.videos;
export const selectIsVideoTourScreen = (state) => state.videos.isVideoTourScreen;
export const selectFocusedVideoIdx = (state) => state.videos.focusedIdx;
export const getBadgeSwitchVideos = (state) => state.videos.items;
export const getSelectedBadgeVideoId = (state) => state.videos.selectedId;

export const getSelectedBadgeVideo = (state) => {
  const items = state.videos.items;
  const selectedId = state.videos.selectedId;

  if (!items.length || !selectedId) {
    return null;
  }

  return items.find((item) => item.id === selectedId);
};

export const selectFocusedVideos = (state) => {
  const videos = state.videos.videos;
  const focusedBadgeSwitchItem = state.videos.selectedId;

  if (!videos || !focusedBadgeSwitchItem) {
    return null;
  }

  return videos[focusedBadgeSwitchItem];
};

export const selectFocusedVideo = (state) => {
  const focusedVideos = selectFocusedVideos(state);

  if (!focusedVideos || !focusedVideos.length) {
    return;
  }

  const focusedIdx = selectFocusedVideoIdx(state);

  return focusedVideos[focusedIdx];
};

export const { setVideos, setIsVideoTourScreen, setFocusedVideoIdx, setBadgeSwitchVideos, setSelectedVideoSwitchId } = videosSlice.actions;

export default videosSlice.reducer;
